module.exports = __webpack_public_path__ + "img/ball-l.59f19f87.png";